//Componentes generales
import React from "react";

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBox
} from "@fortawesome/free-solid-svg-icons";

    const RenderRow = ({ index, style, distribuciones = [], filter }) => {
            if (filter === '') {
                return (
                    <div style={style} className='container-p-list'>
                        <li>
                            <div className='container-p-list-item'>
                                <div className="container-p-list-item-horizontal">
                                    <div className='list-item-icon-p'><FontAwesomeIcon icon={faBox} /></div>
                                    <div className="label-title-products">Dimensión: <div className="label-products">{distribuciones[index].codDim} - {distribuciones[index].codDimDescrp}</div></div>
                                    <div className="label-title-products">Código Distribución: <div className="label-products">{distribuciones[index].codDis}</div> </div>
                                    <div className="label-title-products">Descripción: <div className="label-products">{distribuciones[index].codDisDescrp}</div></div>
                                    <div className="label-title-products">Empresa: <div className="label-products">{distribuciones[index].companyName}</div></div>
                                </div>
                            </div>
                        </li>
                    </div>);
            }else{
                const distribuciones_filters = distribuciones.filter(d => d.codDim.toLowerCase().includes(filter.toLowerCase()) || d.codDimDescrp.toLowerCase().includes(filter.toLowerCase()) || d.codDis.toLowerCase().includes(filter.toLowerCase()) || d.codDisDescrp.toLowerCase().includes(filter.toLowerCase()));
                return (
                    <div style={style} className='container-p-list'>
                        <li>
                            <div className='container-p-list-item'>
                                <div className="container-p-list-item-horizontal">
                                    <div className='list-item-icon-p'><FontAwesomeIcon icon={faBox} /></div>
                                    <div className="label-title-products">Dimensión: <div className="label-products">{distribuciones_filters[index].codDim} - {distribuciones_filters[index].codDimDescrp}</div></div>
                                    <div className="label-title-products">Código Distribución: <div className="label-products">{distribuciones_filters[index].codDis}</div> </div>
                                    <div className="label-title-products">Descripción: <div className="label-products">{distribuciones_filters[index].codDisDescrp}</div></div>
                                    <div className="label-title-products">Empresa: <div className="label-products">{distribuciones_filters[index].companyName}</div></div>
                                </div>
                            </div>
                        </li>
                    </div>);
            }
};

export default RenderRow
